/**
 * STYLES
 */
export const PRIMARY_COLOR = '#192033';
export const SECONDARY_COLOR = '#6AA5FF';
export const TEXT_LIGHT_COLOR = '#FFFFFF';
export const LIGHT_BACKGROUND_COLOR = '#F7F7F8';


/**
 * FONTS
 */
export const PRIMARY_FONT = 'Open Sans, sans-serif';
export const BOLD_FONT = 700;
export const SEMI_BOLD_FONT = 600;


/**
 * MEDIA QUERY
 */
export const QUERY_IPAD = 768;
export const QUERY_IPHONE_6_7_8_PLUS = 414;
export const QUERY_IPHONE_6_7_8 = 375;
export const QUERY_IPHONE_5 = 320;


/**
 * SECTIONS ID
 */
export const ID_ABOUT = 'about'
export const ID_WORK = 'work'
export const ID_PROJECTS = 'projects'
export const ID_CONTACT = 'contact'
